<template>
  <div class="layout_container">
    <div class="classPc">
      <Header />
    </div>
    <div class="classMobile">
      <HeaderMobile />
    </div>
    <div class="layout_main">
      <router-view></router-view>
    </div>

    <div class="classPc">
      <Footer />
    </div>
    <div class="classMobile">
      <FooterMobile />
    </div>
    <Drawer :opens="true"></Drawer>

    <ContactInformation />
  </div>
</template>

<script>
import Header from "./components/header/index.vue";
import HeaderMobile from "./components/header/headerMobile.vue";
import Footer from "./components/footer/index.vue";
import FooterMobile from "./components/footer/footerMobile.vue";
import Drawer from "../components/common/drawer.vue";
import ContactInformation from "../components/common/contactInformation.vue";

export default {
  components: { Header, Footer, Drawer, HeaderMobile, FooterMobile, ContactInformation },
  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang='scss'>
.layout_container {
  padding-top: 64px;
  .layout_main {
    margin: 0 auto;
    min-height: 536px;
  }
}
.classMobile {
  display: none;
}
@media screen and (max-width: 778px) {
  .classPc {
    display: none;
  }
  .classMobile {
    display: block;
  }
  .layout_container {
    padding-top: 4rem;
  }
}
</style>
